import { AuditFormScheduleQuestionResponseDto } from './auditFormScheduleQuestionResponse.dto';
import { BaseDto } from '../base.dto';

export class AuditFormScheduleResponseDto extends BaseDto {
  auditFormScheduleId: number;
  auditFormScheduleQuestionResponses: AuditFormScheduleQuestionResponseDto[];
  auditFormScheduleStatusId: number;
}
